import Mini1 from "../assets/images/Projects/Mini1/Mini1.png";
import Mini2 from "../assets/images/Projects/Mini2/Mini2.png";
import Capstone from "../assets/images/Projects/Capstone/Capstone.png";

const vdatas = [
  
  {
    title: "Attendance Monitoring",
    repo: "https://github.com/chardtmbng02/Mini-Project-01",
    live: "https://bayler-view-hotels.netlify.app/index.html",
    image: Mini1,
    description:
      "An application that record the student's time-in and time-out using rfid then automatically send an SMS to student's guardian.",
    date: "April 2023",
    technologies: ["vB.Net | OleDB"],
  },
  {
    title: "Record Management System",
    repo: "https://github.com/chardtmbng02/chef_murk_kitchen",
    live: "https://cmktm7.vercel.app/",
    image: Mini2,
    description:
      "An application that manage the stock of a business.",
    date: "June 2023",
    technologies: ["vB.Net | OleDB"],
  },
  {
    title: "Simple Calculator",
    repo: "https://github.com/chardtmbng02/baylerview",
    live: "https://baylerview-hotel.vercel.app/",
    image: Capstone,
    description:
      "Software application that performes the basic mathematical operation.",
    date: "July 2023",
    technologies: ["vB.Net", " | ", "OleDB"],
  },
];

export default vdatas;